import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { IMAGES } from "@/data/images";

const imgKeys = ["diver2", "gear", "diver3"];

export const Services = () => {
  const { t } = useLanguage();
  const s = t.scuba.services;
  return (
    <section id="services" className="relative bg-gradient-to-b from-ocean-deep to-ocean-mid py-28 md:py-36 px-6 md:px-12 lg:px-20">
      <div className="mb-16">
        <p className="font-mono text-cyan-300 text-xs tracking-[0.25em] mb-4" data-testid="scuba-services-eyebrow">
          {s.eyebrow}
        </p>
        <h2 className="font-syne text-4xl md:text-5xl tracking-tight text-white max-w-2xl" data-testid="scuba-services-title">
          {s.title}
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {s.items.map((item, i) => (
          <motion.div
            key={item.tag}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, delay: i * 0.12 }}
            className="group relative overflow-hidden rounded-3xl border border-white/15 bg-white/[0.04] hover:border-cyan-300/60 hover:-translate-y-1 transition-all duration-500"
            data-testid={`scuba-service-card-${item.tag}`}
          >
            <div className="relative h-52 overflow-hidden">
              <img
                src={IMAGES.scuba[imgKeys[i]]}
                alt={item.title}
                className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ocean-deep/90 to-transparent" />
              <span className="absolute top-5 left-5 font-mono text-cyan-300 text-sm">{item.tag}</span>
            </div>
            <div className="p-7">
              <h3 className="font-syne text-2xl text-white mb-3">{item.title}</h3>
              <p className="font-manrope text-sm text-white/65 leading-relaxed">{item.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
